import { useState } from 'react';
import { Wallet } from 'lucide-react';
import { useI18n } from '@/i18n';
import { TeamExclusionCheckbox } from '@/components/common';
import { DateRangeSelector } from '@/features/reports/components';
import { CostCenterPanel } from '@/features/reports/components/CostCenterPanel';
import { getRelativeDateRange } from '@/features/reports/dateRange';
import { DEFAULT_EXCLUDE_TEAM } from '@/lib/analytics/teamFilter';

export function CostCenterPage() {
  const { messages, t } = useI18n();

  const [dateRange, setDateRange] = useState(() => getRelativeDateRange(7));
  const [excludeTeam, setExcludeTeam] = useState(DEFAULT_EXCLUDE_TEAM);

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <Wallet className="w-8 h-8 text-blue-600" />
        <h1 className="text-2xl font-bold text-gray-900">{messages.navigation.costCenter}</h1>
      </div>

      <div className="bg-white rounded-xl p-4 mb-6 border border-gray-200">
        <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
          <DateRangeSelector
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            onStartDateChange={(startDate) => setDateRange((current) => ({ ...current, startDate }))}
            onEndDateChange={(endDate) => setDateRange((current) => ({ ...current, endDate }))}
            className="flex-1"
          />
          <TeamExclusionCheckbox
            label={t('reportsPage.filters.excludeTeam')}
            checked={excludeTeam}
            onCheckedChange={setExcludeTeam}
          />
        </div>
      </div>

      <CostCenterPanel startDate={dateRange.startDate} endDate={dateRange.endDate} excludeTeam={excludeTeam} />
    </div>
  );
}
